import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// ── English ────────────────────────────────────────────────────────
import enCommon from './locales/en/common.json';
import enPublic from './locales/en/public.json';
import enArticle from './locales/en/article.json';
import enStaff from './locales/en/staff.json';

// ── French ─────────────────────────────────────────────────────────
import frCommon from './locales/fr/common.json';
import frPublic from './locales/fr/public.json';
import frArticle from './locales/fr/article.json';
import frStaff from './locales/fr/staff.json';

// ── Arabic ─────────────────────────────────────────────────────────
import arCommon from './locales/ar/common.json';
import arPublic from './locales/ar/public.json';
import arArticle from './locales/ar/article.json';
import arStaff from './locales/ar/staff.json';

export { default as enCommon } from './locales/en/common.json';
export { default as enPublic } from './locales/en/public.json';
export { default as enArticle } from './locales/en/article.json';
export { default as enStaff } from './locales/en/staff.json';

export { default as frCommon } from './locales/fr/common.json';
export { default as frPublic } from './locales/fr/public.json';
export { default as frArticle } from './locales/fr/article.json';
export { default as frStaff } from './locales/fr/staff.json';

export { default as arCommon } from './locales/ar/common.json';
export { default as arPublic } from './locales/ar/public.json';
export { default as arArticle } from './locales/ar/article.json';
export { default as arStaff } from './locales/ar/staff.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, public: enPublic, article: enArticle, staff: enStaff },
      fr: { common: frCommon, public: frPublic, article: frArticle, staff: frStaff },
      ar: { common: arCommon, public: arPublic, article: arArticle, staff: arStaff },
    },
    supportedLngs: ['en', 'fr', 'ar'],
    fallbackLng: 'en',
    defaultNS: 'common',
    returnNull: false,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['path', 'navigator'],
      lookupFromPathIndex: 0,
      caches: [],
    },
  });

export default i18n;
